import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import View from '../components/View';
import ViewHeader from '../components/ViewHeader';
import ViewContainer from '../components/ViewContainer';
import ViewContent from '../components/ViewContent';
import ViewTools from '../components/ViewTools';
import Badge from '../components/Badge';
import BackLink from '../components/BackLink';
import PillTabs from '../components/PillTabs';
import StoreList from '../components/StoreList';

import { hideSearch, changeListType, changeFilter } from '../actions/search';
import { setPoint } from '../actions/map';

// data
import Locale from '../data/localization';
import * as listTypes from '../constants/listTypes';
import data from '../data/data';

import { standardize } from '../utils/String'

class SearchView extends Component {

    static propTypes = {
        active: PropTypes.bool.isRequired,
        listType: PropTypes.string,
        type: PropTypes.string,
        value: PropTypes.string,
        label: PropTypes.string,
        dispatch: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            value: props.filter
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.filter !== this.state.value) {
            this.setState({
                value: nextProps.filter
            })
        }

        if (nextProps.active !== this.props.active && nextProps.type !== this.props.type && !this.props.active && this.content) {
            this.content.scrollTo(0,0)
        }
    }

    handleChange(event) {
        if (event.target.value !== this.props.filter) {
            this.props.dispatch(changeFilter(standardize(event.target.value).toLowerCase()));
        }

        if (this.props.listType !== listTypes.SHOPS) {
            this.props.dispatch(changeListType(listTypes.SHOPS));
        }
    }

    handleFocus(event) {
        window.scrollTo(0, this.refs.form.offsetTop)
    }

    handleItemClick(id) {
        this.props.dispatch(setPoint(id, this.props.type));
    }

    handleListChange() {
        this.content.scrollTo(0,0)
    }

    render() {
        const { label, active, listType, type, dispatch } = this.props;

        const pillTabs = [
            {
                label: Locale.search.tabs.popularity,
                value: listTypes.POPULARITY
            },
            {
                label: Locale.search.tabs.alphabet,
                value: listTypes.SHOPS
            },
            {
                label: Locale.search.tabs.categories,
                value: listTypes.CATEGORIES
            }
        ];

        let nodes = [];
        let temp = [];

        const orderBy = listType === listTypes.POPULARITY ? 'popularity' : 'seq';

        return (
            <View type="SearchView" layer={true} active={active}>
                <ViewHeader>
                    <ViewContainer>
                        <BackLink label={label} onClick={() => dispatch(hideSearch())} />
                        <form action="" className="FormSearch" ref="form" onSubmit={event => event.preventDefault()}>
                            <div className="FormSearch-content">
                                <input type="text"
                                    value={this.state.value}
                                    onFocus={::this.handleFocus}
                                    onChange={::this.handleChange}
                                    placeholder={Locale.search.placeholder}
                                    className="FormSearch-field"
                                />
                                <button type="submit" className="FormSearch-button">Vyhledat</button>
                            </div>
                        </form>
                    </ViewContainer>
                </ViewHeader>

                <ViewTools>
                    <PillTabs
                        items={pillTabs}
                        current={listType}
                        onChange={value => dispatch(changeListType(value))}
                    />
                </ViewTools>

                <ViewContent>
                    <div className="Pane is-fixed is-scrollable">
                        <div className="Pane-content" ref={element => this.content = element}>
                            <StoreList
                                orderBy={orderBy}
                                type={listType}
                                filter={this.state.value}
                                onClick={::this.handleItemClick}
                                onChange={::this.handleListChange}
                            />
                        </div>
                    </div>
                </ViewContent>
            </View>
        )
    }

}

function mapStateToProps(state) {
    return state.ui.search;
}

export default connect(mapStateToProps)(SearchView);


// WEBPACK FOOTER //
// ./containers/SearchView.js